import { Box } from "@material-ui/core";
import React, { useEffect, useRef } from "react";
import PlanetWelcomeCard from "../../shared/PlanetWelcomeCard";
import { planetsInformation } from "../collection/data";
import styled, { css } from "styled-components";
import { theme } from "../../Theme";
import Planetimage from "../../shared/PlanetImage";
import { PrimaryBtn } from "../../shared/Buttons";
import { Link, useHistory } from "react-router-dom";
import { flex } from "styled-system";
import { Reciclagem } from "../../img";
import Slider from "../../shared/Slider";
import { Planets } from "../../helper";
import CountDownTimer from "../home/components/CountDownTimer";

const StyledHr = styled.hr`
  border-bottom: 2px solid white;
  margin-top: 50px;
  margin-bottom: 50px;
`;

const StyledImg = styled.img`
  width: 100%;
  margin-top: 20px;
  margin-bottom: 22px;
`;

const NeptunePreSale = () => {
  let history = useHistory();

  return (
    <div>
      <h1 className="text-center" data-aos="fade-up" data-aos-duration="2000">
        A new planet <br />a new adventure
      </h1>
      <h4 className="text-center" data-aos="fade-up" data-aos-duration="2200">
        SOMETHING EXTRAORDINARY IS ABOUT TO LAND THIS JUNE 2025. <br />A WINE
        THAT'S BEEN DESIGNED TO PUSH BOUNDARIES, <br /> DEFY EXPECTATIONS, AND
        TAKE YOUR PALATE TO PLACES IT'S NEVER BEEN BEFORE.
      </h4>
      <StyledImg
        data-aos="zoom-in"
        data-aos-duration="2000"
        src={`../images/NeptunePreSale.jpg`}
        alt="NeptunePreSale"
      />
      <h4 className="text-center" data-aos="fade-up" data-aos-duration="2200">
        ARE YOU READY TO EXPLORE? TO TASTE THE UNKNOWN? <br />
        COUNTDOWN FOR LAUCH BEGINS NOW!
      </h4>
      <br />
      <div data-aos="fade-up" data-aos-duration="1800">
        <CountDownTimer stringDate="June 26, 25 13:00:00" />
      </div>
    </div>
  );
};
export default NeptunePreSale;
